<!-- Header -->
<div class="flex-header" id="studentSearchHeader" (keyup.enter)="searchClick()" style="justify-content: space-between">
    <h3 class="mat-dialog-title" *ngIf="!searchAndSelect">Student Search</h3>
    <h3 class="mat-dialog-title" *ngIf="searchAndSelect">Student Search and Select</h3>
    <div *ngIf="headerMessage && !showLargeHeaderMessage" style="font-weight: bold; color: #a20000;">
        {{headerMessage}}
    </div>
    <div *ngIf="headerMessage && showLargeHeaderMessage">
        <h3>{{headerMessage}}</h3>
    </div>
    <div style="display: flex;">
        <div style="display: flex;align-items: center;">
            Searching students available in Academic Year
            {{currentYear.Description}}
        </div>
        <div *ngIf="!searchAndSelect" style="display: flex; padding-left: 10px">
            <tyl-form-field class="header-input" label="Recent Students">
                <mat-select tabindex="-1" aria-label="Recent Students" id="selectedStudentList">
                    <mat-option (click)="lastSelectedStudentClick(student)"
                        *ngFor="let student of selectedStudentHistory">
                        <student-name [firstName]="student.FirstName" [lastName]='student.LastName'
                            [middleName]='student.MiddleName'>
                        </student-name>
                    </mat-option>
                </mat-select>
            </tyl-form-field>
        </div>
    </div>
</div>
<!-- Body -->
<div class="flex-content">
    <form id="studentSearchControls" (keydown)="keyDownFunction($event)" class="side-padding">
        <div class="label-input-block" *ngIf="defaultCursorPosition == 0">
            <tyl-form-field class="header-input" label="Student #" [errorMessage]="'Invalid CSV'">
                <input [disabled]="checkStudentFilter()" #studentNumber id="studentNumberInput" name="Student #"
                    aria-label="Student Number" matInput [(ngModel)]="searchCriteria.studentNumber"
                    [pattern]="studentNumberRegExp" (keydown)="validateStudentNumberKey($event)" />
            </tyl-form-field>
            <tyl-button image="csv.png" [showLabel]="false" (clickEvent)="enterStudentNumbers()"></tyl-button>
        </div>
        <div class="label-input-block" *ngIf="defaultCursorPosition == 1">
            <tyl-form-field class="header-input" label="Last Name">
                <input [disabled]="checkStudentFilter()" #lastName id="lastNameInputAlt" name="Last Name" matInput
                    aria-label="Last Name" [(ngModel)]="searchCriteria.lastName" />
            </tyl-form-field>
        </div>
        <div class="label-input-block">
            <tyl-form-field class="header-input" label="First Name">
                <input [disabled]="checkStudentFilter()" #firstName aria-label="First Name" matInput name="First Name"
                    id="firstNameInput" [(ngModel)]="searchCriteria.firstName">
            </tyl-form-field>
        </div>
        <div class="label-input-block" *ngIf="defaultCursorPosition != 1">
            <tyl-form-field class="header-input" label="Last Name">
                <input [disabled]="checkStudentFilter()" #lastName id="lastNameInput" name="Last Name" matInput
                    aria-label="Last Name" [(ngModel)]="searchCriteria.lastName" />
            </tyl-form-field>
        </div>
        <div class="label-input-block" *ngIf="defaultCursorPosition != 0">
            <tyl-form-field class="header-input" label="Student #" [errorMessage]="'Invalid CSV'">
                <input [disabled]="checkStudentFilter()" #studentNumber id="studentNumberInput" name="Student #"
                    aria-label="Student Number" matInput [(ngModel)]="searchCriteria.studentNumber"
                    [pattern]="studentNumberRegExp" (keydown)="validateStudentNumberKey($event)" />
            </tyl-form-field>
            <tyl-button image="csv.png" [showLabel]="false" (clickEvent)="enterStudentNumbers()"></tyl-button>
        </div>
        <div class="label-input-block">
            <tyl-form-field class="header-input" label="School">
                <mat-select [disabled]="checkStudentFilter() || disableSchoolDropdown" aria-label="School Select"
                    id="schoolInput" [value]="searchCriteria.schoolId"
                    (selectionChange)="selectedSchoolChanged($event)">
                    <mat-option [value]="allSchoolsValue">
                        (All)
                    </mat-option>
                    <mat-option *ngFor="let school of schools" [value]="school.Id.toString()">
                        {{school.SchoolName}}
                    </mat-option>
                </mat-select>
            </tyl-form-field>
        </div>
        <div class="label-input-block">
            <tyl-form-field class="header-input" label="Status">
                <mat-select [disabled]="checkStudentFilter()" aria-label="Status Select" id="statusInput"
                    [value]="searchCriteria.status" (selectionChange)="selectedStatusChanged($event)">
                    <mat-option value="All">(All)</mat-option>
                    <mat-option value="Active">Active</mat-option>
                    <mat-option value="Inactive">Inactive</mat-option>
                    <mat-option value="Projected">Projected</mat-option>
                </mat-select>
            </tyl-form-field>
        </div>
        <div class="label-input-block" style="display: inline-flex; flex-direction: column;">
            <tyl-form-field class="header-input" label="Student Filter"
                [hint]="checkStudentFilter() && !currentQuery.QueryName ? 'Unsaved Filter Applied' : null">
                <mat-select aria-label="Student Filter Select" id="studentFilterInput" name="studentFilterInput"
                    [(ngModel)]="currentQuery" (selectionChange)="studentFilterChange($event)">
                    <mat-option [value]="null">
                        None
                    </mat-option>
                    <mat-option *ngFor="let recentFilter of information.recentStudentFilters" [value]="recentFilter">
                        {{recentFilter.QueryName}}
                    </mat-option>
                </mat-select>
            </tyl-form-field>
        </div>
        <div class="label-input-block">
            <tyl-form-field class="header-input" label="Student List">
                <mat-select [disabled]="checkStudentFilter()" aria-label="Student List Select" id="studentListInput"
                    name="studentListInput" [(ngModel)]="studentList">
                    <mat-option [value]="null">
                        None
                    </mat-option>
                    <mat-option *ngFor="let studentList of studentLists" [value]="studentList">
                        {{studentList.Name}}
                    </mat-option>
                </mat-select>
            </tyl-form-field>
        </div>
        <div class="label-input-block" style="position: relative; top: -6px">
            <tyl-button image="search normal.png" (clickEvent)="searchClick()" translate></tyl-button>
        </div>
    </form>

    <div class="menuPosition">
        <img class="menuButton" (click)="menuClick()" [matMenuTriggerFor]="gridMenu"
            src="./assets/images/icons/baseline_menu.png" />
        <mat-menu #gridMenu="matMenu">
            <div style="padding-right: 10px;" *ngFor="let col of defaultColumns">
                <mat-checkbox *ngIf="col.name != 'Alerts'" [id]="col.name" [(ngModel)]="col.active"
                    (change)="chooseColumn()" (click)="$event.stopPropagation()">
                    {{col.name}}
                </mat-checkbox>
                <mat-checkbox *ngIf="col.name == 'Alerts' && showStudentAlerts" [id]="col.name" [(ngModel)]="col.active"
                    (change)="chooseColumn()" (click)="$event.stopPropagation()">
                    {{col.name}}
                </mat-checkbox>
            </div>
            <button mat-button (click)="restoreDefaultsClick()">Restore Defaults</button>
        </mat-menu>
    </div>
    <!--***** ONE-6748 ******-->
    <div class='flex-content'>
        <mat-table #table [dataSource]="dataSource" matSortDisableClear matSort id="tblStudentGridData" matSortActive="{{shortingBy}}"
            matSortDirection="asc">
            <!-- Select All Check Box -->
            <ng-container matColumnDef="SelectAll">
                <mat-header-cell *matHeaderCellDef>
                    <mat-checkbox type="checkbox" [(ngModel)]="allStudentsSelected"
                        (change)="selectAllCheckBoxChange()"></mat-checkbox>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <mat-checkbox type="checkbox" class="searchSelectBox" [(ngModel)]="element.isSelected"
                        (change)="selectCheckBoxChange()" (click)="$event.preventDefault()"></mat-checkbox>
                </mat-cell>
            </ng-container>

            <!-- StudentNumber -->
            <ng-container matColumnDef="StudentNumber">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    Student #
                    <filter class="mat-filter" [data]="dataSource" columnName="StudentNumber" dataType="string">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.StudentNumber}}
                </mat-cell>
            </ng-container>

            <!-- FirstName -->
            <ng-container matColumnDef="FirstName">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    First Name
                    <filter class="mat-filter" [data]="dataSource" columnName="FirstName" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.FirstName}}
                </mat-cell>
            </ng-container>

            <!-- LastName -->
            <ng-container matColumnDef="LastName">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    Last Name
                    <filter class="mat-filter" [data]="dataSource" columnName="LastName" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.LastName}}
                </mat-cell>
            </ng-container>

            <!-- StudentAlerts -->
            <ng-container matColumnDef="StudentAlerts">
                <mat-header-cell *matHeaderCellDef>
                    Alerts
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <student-alerts *ngIf="showAlert && element.StudentAlerts" [alerts]="element.StudentAlerts">
                    </student-alerts>
                </mat-cell>
            </ng-container>

            <!-- Grade -->
            <ng-container matColumnDef="Grade">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    Grade
                    <filter class="mat-filter" [data]="dataSource" columnName="Grade" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.Grade}}
                </mat-cell>
            </ng-container>

            <!-- Enrollment -->
            <ng-container matColumnDef="Enrollment">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    Enrollment
                    <filter class="mat-filter" [data]="dataSource" columnName="Enrollment" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.Enrollment}}
                </mat-cell>
            </ng-container>

            <!-- EnrollmentDate -->
            <!-- <ng-container matColumnDef="EnrollmentDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    Enroll Date
                    <filter class="mat-filter" [data]="dataSource" columnName="EnrollmentDate" dataType="date"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.EnrollmentDate | date:'MM/dd/yyyy'}}
                </mat-cell>
            </ng-container> -->

            <!-- EnrollmentDate -->
            <ng-container matColumnDef="EnrollmentDateAsDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    Enroll Date
                    <filter class="mat-filter" [data]="dataSource" columnName="EnrollmentDateAsDate" dataType="date"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.EnrollmentDateAsDate | date:'MM/dd/yyyy'}}
                </mat-cell>
            </ng-container>

            <!-- DateOfBirth -->
            <ng-container matColumnDef="DateOfBirth">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    Birth Date
                    <filter class="mat-filter" [data]="dataSource" columnName="DateOfBirth" dataType="date"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.DateOfBirth | date:'MM/dd/yyyy'}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="DateOfBirthAsDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    Birth Date
                    <filter class="mat-filter" [data]="dataSource" columnName="DateOfBirthAsDate" dataType="date"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.DateOfBirthAsDate | date:'MM/dd/yyyy'}}
                </mat-cell>
            </ng-container>

            <!-- EnrollmentSchool -->
            <ng-container matColumnDef="EnrollmentSchool">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    School
                    <filter class="mat-filter" [data]="dataSource" columnName="EnrollmentSchool" dataType="string">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.EnrollmentSchool}}
                </mat-cell>
            </ng-container>

            <!-- EnrollmentStatus -->
            <ng-container matColumnDef="EnrollmentStatus">
                <mat-header-cell *matHeaderCellDef mat-sort-header style="margin-left: 20px;">
                    Status
                    <filter class="mat-filter" [data]="dataSource" columnName="EnrollmentStatus" dataType="string">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element" style="margin-left: 20px;">
                    {{element.EnrollmentStatus}}
                </mat-cell>
            </ng-container>

            <!-- Homeroom_Teacher -->
            <ng-container matColumnDef="Homeroom_Teacher">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    Homeroom Teacher
                    <filter class="mat-filter" [data]="dataSource" columnName="Homeroom_Teacher" dataType="string">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.Homeroom_Teacher}}
                </mat-cell>
            </ng-container>

            <!-- StudentDOENumber -->
            <ng-container matColumnDef="StudentDOENumber">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    State ID
                    <filter class="mat-filter" [data]="dataSource" columnName="StudentDOENumber" dataType="string">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.StudentDOENumber}}
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></mat-header-row>

            <mat-row *matRowDef="let row; columns: columnsToDisplay; let i = renderIndex;" id="tblTemplatesDataRow{{i}}"
                [ngStyle]="{'border-bottom-width':dataSource.checkExpanded(row) ? '0px' : '1px'}"
                style="padding:0px;overflow: hidden;" matRipple (click)="onSelectionChanged($event,row)"
                (keydown)="dataSource.rowKeyPress($event, row)">
            </mat-row>
        </mat-table>
    </div>
    <mat-paginator [pageSizeOptions]="[100, 250, 500]" showFirstLastButtons></mat-paginator>
</div>

<!-- Footer -->
<div class="flex-footer" id="studentSearchFooter">
    <div class="flex-footer-left">
        <tyl-button image="startover.png" label="Start Over" (clickEvent)="startOverClick()" translate>
        </tyl-button>
        <tyl-button [image]="checkStudentFilter() ? 'filter yellow.png' : 'filter.png'" label="Student Filters"
            (clickEvent)="studentFiltersClick()" translate>
        </tyl-button>
        <tyl-button *ngIf="addStudentList" [image]="creatingStudentList ? 'add disabled.png' : 'add.png'"
            label="Create Student List" [disabled]="creatingStudentList" (clickEvent)="createStudentList()">
        </tyl-button>
        <tyl-button *ngIf="searchAndSelect"
            [image]="selectedStudents.length == 0 ? 'student black.png' : 'student yellow.png'"
            label="Selected Students" (clickEvent)="showSelectedStudents()" translate>
        </tyl-button>
        <tyl-button [disabled]="(searchAndSelect && selectedStudents.length == 0) || (!searchAndSelect && dataSource.filteredData.length == 0)"
            image="email button.png"
            disabledImage="email button disabled.png"
            label="Mass Email"
            (clickEvent)="massEmail()"
            translate></tyl-button>
    </div>
    <div class="flex-footer-middle">
        <filter-notification [filtered]="dataSource.isFiltered()" (clearFilter)="clearFilter()"></filter-notification>
    </div>
    <div class="flex-footer-right">
        <tyl-button *ngIf="searchAndSelect && !hideSaveButton" image="save.png" [label]="acceptLabel" (clickEvent)="selectClick()"
            translate>
        </tyl-button>
        <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="closeClick()" translate></tyl-button>
        <tyl-button *ngIf="searchAndSelect && !hidNextButton" image="next arrow.png" label="Next" (clickEvent)="selectClick()"></tyl-button>
    </div>
</div>
